import { getData } from './dataFetching';

// Asks the API whether a hierarchical-settings scope is available for the signed-in
// account. The answer is the global default on the scope definition
// (`available_by_default`), overridden per account by an administrator
// (`admin_available`) — so a feature can be off by default and turned on for one
// account, or the other way round, without a deploy.
//
// Fails open. These gates decide what the portal offers, not what the API allows —
// the underlying endpoints keep their own authorization — so a portal that cannot
// reach the settings endpoint behaves as it did before the gate existed.
// `ScopeNotRegistered` is treated the same way on purpose: it is the expected state
// between deploying the portal and the api-accounts restart that registers the scope.
export const isFeatureAvailable = async (scope) => {
  const resolved = await getData(`accounts/default/settings/${scope}/resolved`);

  if (!resolved || resolved.reason === 'ScopeNotRegistered') {
    return true;
  }

  return resolved.available !== false;
};
